import {withRouter} from 'react-router-dom';
import Icon from '@components/common/Icon';
import {Button} from '@ultradent/components';
import {LOGIN_URL} from '@util/URLUtils';

const RegistrationLocked = ( props ) => {
    const errorMessage = props.location.state && props.location.state.errorMessage || null;

    return (
        <div className="universalForm-container my-4 md:my-12 mx-auto">
            <Icon.ui
                className="text-5xl"
                wrapperClassName="justify-center text-fail"
                center
                name="account-locked"
            />
            <h2 className="text-center text-fail text-2xl">Registration Locked</h2>
            {errorMessage &&
                <p className="text-center my-4"><strong>{errorMessage}</strong></p>
            }
            <p className="text-center">Please call our customer service at <strong>
                <a className="link-2" href={`tel:${upi.conf.phoneTollFree}`}>{upi.conf.phoneTollFree}</a>
            </strong> to help resolve the problem.
            </p>

            <div>
                <h2 className="text-lg text-center mt-16 mb-4">Already have an online account?</h2>
                <div className="flex md:flex-row justify-center items-center">
                    <div className="flex-0">
                        <Button as="a" href={LOGIN_URL} tertiary fill>Sign in</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter( RegistrationLocked );